import React, { Fragment, useCallback, useEffect, useState } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import PageTitle from '../../../Layout/AppMain/PageTitle';

import {
    Button,
    Form,
    FormGroup,
    Label,
    Col,
    Card,
    CardBody,
    Container,
    Modal,
    ModalHeader,
    ModalBody, Input
} from 'reactstrap';

import { useForm } from 'react-hook-form';
import { useAuth } from '../../../Context/Auth/AuthContext';
import api from '../../../services/api';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import InputMask from 'react-input-mask';

export default function ContactInfo() {
    const { toggleLoading, authenticated, logout } = useAuth();
    const { register, handleSubmit, setValue } = useForm({});
    const history = useHistory();
    const [passwordDel, setPasswordDel] = useState('');

    const [modalDelete, setModalDelete] = useState(false);
    const toggleModalDelete = useCallback(() => {
        setModalDelete(!modalDelete);
    }, [setModalDelete, modalDelete]);

    const userInfo = useCallback(() => {
        if (authenticated.user) {
            return authenticated.user;
        } else {
            return authenticated;
        }
    }, [authenticated]);

    useEffect(() => {
        setValue('email', userInfo().email);
        setValue('phone', userInfo().phone);
        setValue('name', userInfo().name);
    }, [setValue, userInfo]);

    const onSubmit = useCallback(
        async ({ name, phone }) => {
            toggleLoading(true);
            api.patch('/ro.team.modifyUser', {
                name,
                phone,
                idCognito: userInfo().idCognito,
                id: userInfo().id,
            })
                .then((response) => {
                    const currentUser = userInfo();
                    currentUser.name = name;
                    currentUser.phone = phone;
                    localStorage.setItem(
                        '@Reachout:user',
                        JSON.stringify(currentUser)
                    );
                    toast.success('Your Contact Info has been changed!');
                    toggleLoading(false);
                })
                .catch((err) => {
                    toast.error('An error ocurred, try again');
                })
                .finally(() => {
                    toggleLoading(false);
                });
        },
        [toggleLoading, userInfo]
    );

    const handleLogout = useCallback(async () => {
        await logout();
        history.push('/');
    }, [logout, history]);

    const deleteAccount = useCallback(() => {
        if (userInfo().email.includes('demoemail.org')) {
            toast.error('Demo accounts are protected during beta tests. Some functions such as delete/transfer group, leave group, and delete account are disabled.');
            return false;
        }
        if (passwordDel === undefined || passwordDel === '' || passwordDel === ' ' || passwordDel.length < 5) {
            toast.error('Type your password to delete your account.');
            return false;
        }
        toggleLoading(true);
        api.patch(`/ro.team.deleteAccount`, {
            password: passwordDel
        })
            .then(() => {
                toast.success('Your account has been deleted. Thank you!');
                toggleModalDelete();
                handleLogout();
            })
            .catch(() => {
                toast.error('An error ocurred, try again');
            })
            .finally(() => {
                toggleLoading(false);
            });
    }, [toggleModalDelete, toggleLoading, handleLogout, userInfo, passwordDel]);

    return (
        <Fragment>
            <CSSTransitionGroup
                component="div"
                transitionName="TabsAnimation"
                transitionAppear={true}
                transitionAppearTimeout={0}
                transitionEnter={false}
                transitionLeave={false}
            >
                <PageTitle
                    heading="Contact Info"
                    subheading="Here you can change your personal contact info."
                    icon="pe-7s-user icon-gradient bg-ripe-malin fontWeigth800"
                />
                <Container fluid>
                    <Card className="main-card mb-3">
                        <CardBody>
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                <FormGroup row>
                                    <Label for="name" sm={2}>
                                        Name
                                    </Label>
                                    <Col sm={10}>
                                        <input
                                            type="text"
                                            name="name"
                                            id="name"
                                            placeholder="Your name"
                                            ref={register}
                                            className="form-control"
                                        />
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label for="phone" sm={2}>
                                        Phone
                                    </Label>
                                    <Col sm={10}>
                                        {/* <input
                                            type="text"
                                            name="phone"
                                            id="phone"
                                            placeholder="Your Phone Number"
                                            ref={register}
                                            className="form-control"
                                        /> */}
                                        <InputMask
                                            mask="(999) 999-9999"
                                            type="text"
                                            name="phone"
                                            id="phone"
                                            placeholder="Your Phone Number"
                                            inputRef={register}
                                            className="form-control"
                                            defaultValue={userInfo().phone}
                                        />
                                    </Col>
                                </FormGroup>
                                <FormGroup check row>
                                    <Col sm={{ size: 15, offset: 2 }}>
                                        <Button
                                            type="submit"
                                            value="Submit"
                                            color="success"
                                        >
                                            Ok
                                        </Button>
                                        <Button
                                            color="secondary"
                                            className="ml-2"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                history.push('/groups');
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                    </Col>
                                </FormGroup>
                            </Form>
                        </CardBody>
                    </Card>

                    <Card className="main-card mb-3">
                        <CardBody>
                            <p>Other options:</p>
                                <Button
                                    className="mb-2 mr-2"
                                    color="danger"
                                    size="sm"
                                    onClick={toggleModalDelete}
                                >
                                    Delete Account
                                </Button>
                                <Modal
                                    isOpen={modalDelete}
                                    toggle={toggleModalDelete}
                                >
                                    <ModalHeader
                                        toggle={toggleModalDelete}
                                    >
                                        Delete Account
                                    </ModalHeader>
                                    <ModalBody>
                                        <div className="text-center">
                                            <p>This action can't be undone. Are you shure?</p>

                                            <Form>
                                                <FormGroup row>
                                                    <Col sm={{size: 8, offset: 2}}>
                                                        <Label>
                                                            Type your password to confirm deletion
                                                        </Label>
                                                        <Input
                                                            className="form-control"
                                                            placeholder="Your password"
                                                            type="password"
                                                            onChange={(e) => {
                                                                setPasswordDel(e.target.value);
                                                            }}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Form>

                                            <Button
                                                color="danger"
                                                onClick={deleteAccount}
                                            >
                                                Yes, Delete My Acccount
                                            </Button>
                                            <Button
                                                color="secondary"
                                                className="ml-2"
                                                onClick={toggleModalDelete}
                                            >
                                                Cancel
                                            </Button>
                                        </div>
                                    </ModalBody>
                                </Modal>
                        </CardBody>
                    </Card>

                </Container>
            </CSSTransitionGroup>
        </Fragment>
    );
}
